
import BaseLayout from './BaseLayout.vue'

export default {
  name: 'OfflineMode',
  components: {
    BaseLayout
  }
}
